module.exports = __webpack_public_path__ + "static/media/alaa falah.ccf7ef80.png";